import styled, { css } from 'styled-components';
import { softCardInteraction } from '@/theme/interactions';

export const focusRing = css`
  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.color.focusRing};
    outline-offset: 3px;
  }
`;
export const Surface = styled.section`
  ${softCardInteraction}
  min-width: 0;
  border: 1px solid ${({ theme }) => theme.color.glassBorder};
  border-radius: ${({ theme }) => theme.radius.md};
  background: ${({ theme }) => theme.surfaceGradients.panel}, ${({ theme }) => theme.color.surface};
`;
export const Muted = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.color.textMuted};
  font-size: ${({ theme }) => theme.fontSize.xs};
  line-height: 1.6;
`;
export const SmallTitle = styled.h2`
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0;
  font-size: ${({ theme }) => theme.fontSize.sm};
  font-weight: 600;
`;
export const Control = styled.button`
  ${focusRing}
  min-height: 40px;
  min-width: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 8px 12px;
  border: 1px solid ${({ theme }) => theme.color.glassBorder};
  border-radius: ${({ theme }) => theme.radius.sm};
  color: ${({ theme }) => theme.color.textPrimary};
  background: ${({ theme }) => theme.color.surface};
  font: inherit;
  font-size: ${({ theme }) => theme.fontSize.xs};
  cursor: pointer;
  &:hover {
    background: ${({ theme }) => theme.color.hover};
  }
`;
export const Select = styled.select`
  ${focusRing}
  max-width: 100%;
  min-height: 38px;
  padding: 8px 28px 8px 10px;
  border: 1px solid ${({ theme }) => theme.color.glassBorder};
  border-radius: ${({ theme }) => theme.radius.sm};
  background: ${({ theme }) => theme.color.surface};
  color: ${({ theme }) => theme.color.textPrimary};
  font: inherit;
  font-size: ${({ theme }) => theme.fontSize.xs};
  cursor: pointer;
`;
export const Chips = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
`;
export const Chip = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 5px 11px;
  border: 1px solid ${({ theme }) => theme.color.glassBorder};
  border-radius: ${({ theme }) => theme.radius.pill};
  color: ${({ theme }) => theme.color.textMuted};
  background: ${({ theme }) => theme.color.glassBg};
  font-size: ${({ theme }) => theme.fontSize.xs};
  line-height: 1.2;
  white-space: nowrap;
`;
export const Version = styled.span`
  color: ${({ theme }) => theme.color.brandFrom};
  font-weight: 750;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
`;
